import { createSelector } from 'reselect'

import { selectGeneralReportSettings } from 'partner360/features/generalReports'
import { IReportSettings } from 'partner360/models/report/generalReports/IReportSettings'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectReportForSelectedGeneralReportsRoots = createSelector(
  [selectGeneralReportsState, selectGeneralReportSettings],
  ({ selectedRoots }, data) => {
    return selectedRoots.reduce(
      (acc, parentId) => {
        const reports = data.filter((el) => el.ParentId === parentId)
        return { ...acc, [parentId]: reports }
      },
      {} as Record<string, IReportSettings[]>
    )
  }
)
